import { ISearchFormValues } from "../types/Form.types";

const FeedbackMessages = {
  searchTermRequired: "Search term is required",
  searchTermMin: "Search term must be at least 3 characters",
  searchTermMax: "Search term cannot exceed 70 characters",
};

const InitialSearchValues: ISearchFormValues = {
  searchTerm: "",
};

export default {
  FeedbackMessages,
  InitialSearchValues,
};
